import { useQueries } from '@tanstack/react-query';
import type { Variables } from 'graphql-request';
import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import type { UseQueryResult } from '@tanstack/react-query';

import { generateBasicQueryOptions } from './useGraphQLBasicQuery.hook';
import { useQueryErrorHandler } from './useGraphQLQuery.hook';
import type { QueryOptions } from './useGraphQLBasicQuery.hook';

interface QueryParam<
  TResult,
  TVariables extends Variables | undefined,
  TError extends Error = Error,
> {
  readonly document: TypedDocumentNode<TResult, TVariables>;
  readonly variables?: TVariables;
  readonly useQueryOptions?: QueryOptions<TResult, TError>;
}

export function useGraphQLQueries<
  TResult,
  TVariables extends Variables | undefined,
  TError extends Error = Error,
>(
  params: readonly QueryParam<TResult, TVariables, TError>[],
): readonly UseQueryResult<TResult>[] {
  const queries = useQueries({
    queries: params.map(generateBasicQueryOptions),
  });

  useQueryErrorHandler({
    isError: queries.some((query) => query.isError),
    error: queries.find((query) => query.isError)?.error,
  });

  return queries;
}
